<template>
  <v-tooltip v-model="showDeleteTooltip" v-bind="{ [tooltipPosition]: true }">
    <template v-slot:activator="{ on }">
      <v-btn
        outlined
        small
        @click="clickHandler"
        :loading="loading"
        title="Delete"
        v-on="on"
        :aria-label="tooltip"
        color="red darken-2"
        ><template v-if="!confirmDelete">
          <v-icon color="red darken-2" small left class="ml-0"
            >mdi-delete</v-icon
          >Delete
        </template>

        <span v-else>Ok?</span></v-btn
      >
    </template>
    <span>{{ confirmDelete ? 'This Cant be Undone' : tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BtnDeleteConfirmation',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: 'Delete',
    },
    tooltipPosition: {
      type: String,
      default: 'top',
    },
  },
  components: {},
  data() {
    return {
      showDeleteTooltip: false,
      confirmDelete: false,
    }
  },
  methods: {
    clickHandler() {
      if (!this.confirmDelete) {
        this.confirmDelete = true
        setTimeout(() => {
          this.confirmDelete = false
        }, 2500)
        return false
      }
      this.isDeleting = true
      this.$emit('delete')
      setTimeout(() => {
        this.isDeleting = false
        this.deleteError = true
      }, 4000)
    }, // clickHandler
  },
}
</script>
